export const MAX_NOTE_LENGTH = 500;

export const MAX_STATIONS_PER_REQUEST = 100;

export const REFUSED_MESSAGE = "Managing alert exclusions requires an administrator entitlement.";

export const REMOVAL_WARNING =
  "Alerting resumes from the next run. If the station is public and still offline past 4 hours, its owners will be alerted.";

/** Prefers the server's own explanation over axios' generic one. */
export const errorMessageOf = (error: any): string =>
  error?.response?.data?.message ?? error?.message ?? "Request failed";

export const isRefusal = (error: any): boolean => error?.response?.status === 403;
